export const saveBotsActionType = "SAVE_PRODUCTS";
export const getBotsActionType = "GET_PRODUCTS"
export const saveCurrentBotActionType = "SAVE_CURRENT_PRODUCTS"
export const saveFilterListProdnType = "SAVE_FILTERLIST_PRODUCTS"
export const editCurrentBotActionType = "EDIT_CURRENT_PRODUCTS"
export const getBotsFailed = "GET_PRODUCTS_FAILED"
